// src/ImageComponent.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Scene from './Scene';
import AnimationComponent from './AnimationComponent'
import PFPComponet from './PFPComponet';


const ImageComponent = () => {
    const [imageData, setImageData] = useState(null);
    const [plateColor, setPlateColor] = useState('')
    const [backgroundImage, setBackgroundImage] = useState('')
    const { number } = useParams();

    const [toggleTwoD, setToggleTwoD] = useState(false)
    const [toggleVoxel, setToggleVoxel] = useState(false)
    const [togglePFP, setTogglePFP] = useState(true)
    const [displaySelector, setDisplaySelector] = useState(0)
    const [isMounted, setIsMounted] = useState(false)

    
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await fetch(`https://dc.yolokidz.io/api/${number}`);
          //const response = await fetch(`${process.env.PUBLIC_URL}${revealed ? `/data/${number}.json` : `/data/unrevealed.json`}`);
          const data = await response.json();
          setImageData(data);
          setPlateColor(data?.attributes[9]?.value)
          setBackgroundImage(data?.attributes[0]?.value)
          
        } catch (error) {
          console.error('Error fetching JSON data:', error);
        }
      };
      fetchData();
    }, [number]);

    // console.log(number)

    const toggleDisplay = () => {
      setToggleVoxel(!toggleVoxel);
    };

    useEffect(() => {
      if (displaySelector === 0) {
        setToggleVoxel(false)
        setToggleTwoD(false)
        setTogglePFP(true)
      } else if (displaySelector === 1) {
        setToggleTwoD(false)
        setTogglePFP(false)
        setToggleVoxel(true)
      } else if (displaySelector === 2) {
        setToggleVoxel(false)
        setTogglePFP(false)
        setToggleTwoD(true)
      }
    }, [displaySelector])

    useEffect(() => {
      setIsMounted(true)
    }, [])
    
    
    console.log(backgroundImage)
    // console.log(plateColor)
    return (
      <div>
        {imageData && isMounted && (
          <>
            {toggleTwoD && <AnimationComponent number={number} setDisplaySelector={setDisplaySelector} backgroundImage={backgroundImage}/>}
            {toggleVoxel && <Scene number={number} plateColor={plateColor} imageData={imageData} setDisplaySelector={setDisplaySelector}/>}
            {togglePFP && <PFPComponet image={imageData.image} number={number} toggleDisplay={toggleDisplay} setDisplaySelector={setDisplaySelector} />}
          </>
        )}
      </div>
    );
  };
  
  export default ImageComponent;

